import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { PlanningOverzichtSimpelKlantComponent } from './planningoverzichtsimpelKlant.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {ListboxModule} from 'primeng/listbox';
import {DropdownModule} from 'primeng/dropdown';
import { AuthGuard } from 'app/core/services/auth.guard';
import { PlanningKlantGegevensDialog } from './planningKlantGegevens/planningKlantGegevensDialog';

const routes = [
    {
        path     : 'planning/overzichtsimpelklant',
        component: PlanningOverzichtSimpelKlantComponent,
        canActivate: [AuthGuard],
        data: { roles: ['Klant'] } 
    }
];

@NgModule({
    declarations: [
        PlanningOverzichtSimpelKlantComponent,
        PlanningKlantGegevensDialog
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatCheckboxModule,
        MatTableModule,
        MatNativeDateModule,
        MatSortModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        TranslateModule,
        MatInputModule,
        FuseSharedModule,
        MultiSelectModule,
        MatDatepickerModule,  
        MatRadioModule,
        ListboxModule,
        MatDialogModule,
        DropdownModule
        
    ],
    exports     : [
        PlanningOverzichtSimpelKlantComponent
    ]
})

export class PlanningOverzichtSimpelKlantModule
{
}
